import { BaseService } from "./baseService";
class EmployeeCrewService extends BaseService {
    constructor() {
        super(...arguments);
        this.controllerName = "employee_crew";
    }
}
export const employeeCrewService = new EmployeeCrewService();
//# sourceMappingURL=employeeCrewService.js.map